/* Keep the 3D ring's metal in step with the variant the customer picks.
   The theme builds the viewer URL server side as .../viewer.html?model=<glb>&metal=<metal>, so the
   iframe keeps whatever metal the first render resolved. This watches the variant controls, works
   out the Metal Color value, and swaps the metal parameter, which makes the viewer reload in the
   right colour. It listens to plain DOM change events rather than any theme-specific event, so it
   does not depend on how the variant picker is implemented.

   Android is opted out of the viewer entirely, so there init() returns straight away. */
(function () {
  'use strict';

  /* mirror the theme's own server side mapping in product-media-gallery.liquid */
  function metalFrom(text) {
    var t = String(text || '').toLowerCase();
    if (!t) return null;
    if (t.indexOf('rose') > -1) return 'rose';
    if (t.indexOf('platinum') > -1 || t.indexOf('white') > -1) return 'white';
    if (t.indexOf('yellow') > -1 || t.indexOf('gold') > -1) return 'gold';
    return null;
  }

  function viewerMetal(scope) {
    var o = scope.querySelector('[data-p3d-metal]');
    return o ? (o.getAttribute('data-p3d-metal') || '').toLowerCase() : null;
  }

  function readSelectedMetal(scope) {
    /* radio buttons first, then selects, since a theme may use either */
    var radios = scope.querySelectorAll('input[type="radio"]:checked');
    for (var i = 0; i < radios.length; i++) {
      var name = (radios[i].name || '').toLowerCase();
      var label = (radios[i].closest('label') || radios[i]).textContent || '';
      var m = metalFrom(label);
      if (m && /metal/.test(name)) return m;
      if (m && /metal/.test(name)) return m;
      if (m && !/size|length|width/i.test(name)) return m;
    }

    var selects = scope.querySelectorAll('select');
    for (var j = 0; j < selects.length; j++) {
      var s = selects[j];
      var opt = s.options[s.selectedIndex];
      if (!opt) continue;
      var nm = ((s.name || '') + ' ' + (s.id || '') + ' ' + (s.previousElementSibling && s.previousElementSibling.textContent || '')).toLowerCase();
      if (!/metal/.test(nm)) continue;
      var mm = metalFrom(opt.textContent);
      if (mm) return mm;
    }
    return null;
  }

  function apply(scope) {
    var frames = scope.querySelectorAll('.p3d-slide iframe');
    if (!frames.length) return;
    var locked = viewerMetal(scope);
    var want = locked || readSelectedMetal(scope);
    if (!want) return;

    frames.forEach(function (f) {
      /* A frame parked at about:blank has no viewer to recolour yet: the theme points it at the
         viewer when the 3D slide comes near the viewport, and the metal travels with that URL.
         Rewriting a parked frame here would only give it a bogus about:blank?metal=... address,
         which then reads as "already loaded" and leaves the slide blank. */
      var parked = f.getAttribute('src');
      if (!parked || parked === 'about:blank' || parked.indexOf('about:blank?') === 0) return;

      var url;
      try { url = new URL(f.src, window.location.origin); } catch (e) { return; }
      if (url.searchParams.get('metal') === want) return;
      url.searchParams.set('metal', want);
      f.src = url.toString();
    });
  }

  function init() {
    /* Android is opted out of the 3D viewer entirely, see the note at the foot of
       section-product-3d-embed.css. There is no viewer to recolour there, so there is nothing to
       keep in step, and skipping init also spares Android the URL poll and the mutation observer
       below. */
    if (document.documentElement.getAttribute('data-cj-os') === 'android') return;

    document.querySelectorAll('media-gallery').forEach(function (g) { apply(g); });

    /* any variant interaction bubbles a change event */
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !/^(INPUT|SELECT)$/.test(t.tagName)) return;
      var form = t.closest('form, product-info, [data-product-root]') || document;
      var g = form.querySelector('media-gallery');
      if (g) apply(g);
    }, true);

    /* the theme may swap options without firing change, so watch the URL too */
    var lastUrl = location.href;
    setInterval(function () {
      if (location.href === lastUrl) return;
      lastUrl = location.href;
      document.querySelectorAll('media-gallery').forEach(function (g) { apply(g); });
    }, 400);

    /* and watch for a re-rendered variant picker */
    var obs = new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.type === 'childList' && m.addedNodes.length) {
          document.querySelectorAll('media-gallery').forEach(function (g) { apply(g); });
        }
      });
    });
    var host = document.querySelector('product-info') || document.body;
    if (host) obs.observe(host, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();